import { CurationItem } from "../../types";
import { createMenuContainer, getRequiredPublisherId, updateMenuContainer } from "./helpers";

export const createFooter = async (parentId: string): Promise<CurationItem> => {
    if (!parentId) {
        throw new Error("createFooter requires a parentId.");
    }

    const publisherId = getRequiredPublisherId();
    const newFooter = await createMenuContainer(parentId, publisherId, "Footer");

    const updateBody: CurationItem = {
        ...newFooter,
        title: "Footer",
        metadata: {
            ...newFooter.metadata,
            default: {
                ...newFooter.metadata.default,
                "layout-menu-position": "Footer",
            },
            en_US: {
                ...newFooter.metadata.en_US,
                title: "Footer",
            },
        },
    };

    await updateMenuContainer(newFooter.id, updateBody, "Footer");

    return newFooter;
};
